import React from "react";
import {
    FormLayout,
    HeaderActions,
    Heading,
    Input,
    LoadingProgress,
    Panel,
    Switch,
    Text,
} from "@/ui";
import { Icon } from "@/components";
import useMeta from "../../base/hooks/useMeta";
import useForm from "../../base/hooks/form/useForm";
import useFormActions from "../../base/hooks/form/useFormActions";
import {
    MUTATION_UPDATE_FEEFO,
    QUERY_LIST_STORE_APPS,
} from "../../apollo/module-operations/app";
import _ from "lodash";
import useValidator from "../../base/hooks/form/useValidator";
import styles from "./GeneralsForm.module.scss";

const SaveIcon = () => <Icon icon="save" />;

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const FeefoForm = ({ app }) => {
    const { user } = useMeta();
    const { inputs, setInputs, inputChange } = useForm();

    if (!_.get(inputs, "id", null)) {
        setInputs(app);
    }

    let options = {
        variables: {
            account_id: user.accountId,
            store_id: user.storeId,
            input: {
                ...inputs,
            },
        },
    };

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "merchant_identifier",
                method: "isEmpty",
                validWhen: false,
                message: "This merchant identifier is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    const { createOrUpdate, loading } = useFormActions(
        "id",
        "Feefo",
        "",
        MUTATION_UPDATE_FEEFO,
        [
            {
                query: QUERY_LIST_STORE_APPS,
                variables: {
                    account_id: user.accountId,
                    store_id: user.storeId,
                },
                skip: user.loading || !user.accountId || !user.storeId,
            },
        ],
        options,
        "",
        isValid,
        isSubmited,
        "primary",
    );

    return (
        <Panel
            className={styles.root}
            header={
                <div className={styles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>Feefo</Heading>
                        <Text tone="secondary" variant="body-sm">
                            Feefo Information
                        </Text>
                    </div>
                    <HeaderActions
                        actions={[
                            {
                                id: "update",
                                label: "Update",
                                icon: loading ? undefined : <SaveIcon />,
                                loading,
                                disabled: loading,
                                onClick: () => createOrUpdate(),
                            },
                        ]}
                        aria-label="Feefo actions"
                    />
                </div>
            }
            showHeaderDivider
        >
            {user.loading ? (
                <div className={styles.loading}>
                    <LoadingProgress
                        indeterminate
                        indicator="circular"
                        size="sm"
                        title="Loading"
                    />
                </div>
            ) : (
                <FormLayout>
                    <FormLayout.Section title="Information">
                        <Switch
                            checked={Boolean(inputs.used_for_subscription)}
                            label="Used for subscription"
                            name="used_for_subscription"
                            onChange={inputChange}
                        />
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(
                                    validator,
                                    "merchant_identifier",
                                )}
                                fullWidth
                                label="Merchant Identifier"
                                name="merchant_identifier"
                                onChange={inputChange}
                                value={inputs.merchant_identifier || ""}
                            />
                        </FormLayout.Grid>
                    </FormLayout.Section>
                </FormLayout>
            )}
        </Panel>
    );
};

export default FeefoForm;
